<template>
  <div :class="['c-popup', { 'c-popup--active': showPopup }]">
    <span
      class="c-popup__overlay"
      @click="$emit('closePopup')"
    />
    <div class="c-popup__inner">
      <div class="c-popup__title">
        <slot name="title" />
      </div>
      <div class="c-popup__content">
        <slot name="content" />
      </div>
      <div class="c-popup__buttons">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showPopup: {
      type: Boolean,
      default: false
    }
  }
};
</script>
